<div class="d-flex vh-100 app-layout">
  
  <!-- MOBILE HAMBURGER BUTTON -->
  <!-- <button class="sidebar-toggle-btn d-md-none" (click)="isSidebarOpen = !isSidebarOpen">
    <i class="fa-solid fa-bars"></i>
  </button> -->
   <header class="mobile-header d-md-none">
    <button class="sidebar-toggle-btn" (click)="toggleSidebar()">
      <i class="fa-solid fa-bars"></i>
    </button>
    <span class="mobile-title">{{username }}</span> <!--{{ utils.companyName }}-->
  </header>

   <!-- OVERLAY FOR MOBILE -->
  <!-- <div class="sidebar-overlay" *ngIf="isSidebarOpen" (click)="isSidebarOpen = false"></div> -->
  <div class="sidebar-overlay" *ngIf="isSidebarOpen" (click)="closeSidebar()"></div>

  <!-- SIDEBAR -->
  <nav class="sidebar p-4 d-flex flex-column" [class.open]="isSidebarOpen">

    <!-- BRAND / HEADER -->
    <div class="sidebar-header text-center mb-4">
      <img src="assets/logo.png" class="sidebar-logo mb-2" alt="SiDrive Logo">
      <h6 class="username mb-1">{{ username }}</h6> <!-- User Name -->
      <hr>
    </div>


    <!-- MENU -->
    <ul class="nav flex-column sidebar-menu mb-4">
      <li class="nav-item" *ngFor="let tab of tabs">
        <a class="nav-link sidebar-link" [class.text-muted]="!tab.enabled" [class.disabled]="!tab.enabled"
          [routerLink]="[tab.path]" routerLinkActive="active" (click)="!tab.enabled && $event.preventDefault()">
          {{ tab.label }}
        </a>
      </li>
    </ul>

    <!-- ACTION BUTTONS -->
    <!-- <div class="sidebar-actions mt-auto d-flex flex-column gap-2">
      <button class="action-btn save" (click)="onSave()">
        <i class="fa-solid fa-floppy-disk me-2"></i> Save
      </button>

      <button class="action-btn submit" (click)="onSubmit()">
        <i class="fa-solid fa-paper-plane me-2"></i> Submit
      </button>
    </div> -->

    <!-- LOGOUT BUTTON SEPARATE -->
    <div class="logout-section mt-4">
      <button class="action-btn logout w-100" (click)="onLogout()">
        <i class="fa-solid fa-right-from-bracket me-2"></i> Logout
      </button>
    </div>


  </nav>

  <!-- MAIN CONTENT -->
  <div class="flex-grow-1 content-area p-4">
    <router-outlet></router-outlet>
  </div>

</div>




